import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CheckValidations {
  limitKms = 0;
  limitMonths = 0;

  checkValidations(
    estimatedKms: number,
    limitKms: number,
    deliveryDate: string | undefined,
    limitMonths: number
  ): boolean {
    if (!deliveryDate) {
      throw new Error('Fecha de entrega no definida');
    }
    const limitMonthsDef = limitMonths - 3;
    const deliveryDateObj = new Date(deliveryDate);
    const newDate = this.transformDate(deliveryDateObj, limitMonthsDef);
    const today = new Date();

    return estimatedKms < limitKms && today < newDate;
  }

  transformDate(deliveryDate: Date, months: number): Date {
    const result = new Date(deliveryDate);
    result.setMonth(result.getMonth() + months);

    return result;
  }
}
